import { render } from "./CookieConsentNew.vue?vue&type=template&id=7ea705fa"
import script from "./CookieConsentNew.vue?vue&type=script&lang=js"
export * from "./CookieConsentNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__